import { z } from 'zod';
import type { FormValidationMessages } from '@eliadmin/core/src/hooks/use-form-validation-messages';

export const reservationSchema = (VM: FormValidationMessages) =>
  z.object({
    arrival: z.preprocess(
      v => (v === '' ? undefined : v),
      z.date({ error: VM.CANT_BE_EMPTY_VALIDATION_MESSAGE() }),
    ),
    departure: z.preprocess(
      v => (v === '' ? undefined : v),
      z.date({ error: VM.CANT_BE_EMPTY_VALIDATION_MESSAGE() }),
    ),
    guests_count: z.coerce
      .number({ error: VM.CANT_BE_EMPTY_VALIDATION_MESSAGE() })
      .min(2, VM.CANT_BE_EMPTY_VALIDATION_MESSAGE()),
    property_id: z.number(),
    name: z.string().min(1, VM.CANT_BE_EMPTY_VALIDATION_MESSAGE()),
    surname: z.string().min(1, VM.CANT_BE_EMPTY_VALIDATION_MESSAGE()),
    email: z.string().email(VM.EMAIL_INVALID_VALIDATION_MESSAGE()),
    phone: z.string().optional(),
    note: z.string().optional(),
    gdpr: z.boolean().refine(val => val === true, {
      message: VM.GDPR_VALIDATION_MESSAGE(),
    }),
    tos: z.boolean().refine(val => val === true, {
      message: VM.TOS_VALIDATION_MESSAGE(),
    }),
    'g-recaptcha-response': z.string().default(''),
  });

export type ReservationFormValues = z.output<ReturnType<typeof reservationSchema>>;
export type ReservationFormInputValues = z.input<ReturnType<typeof reservationSchema>>;
